import EventEmitter from 'eventemitter3'

export const events = new EventEmitter()

export const MERCHANT_PRICING_ADDED = 'merchant_pricing.added'
export const MERCHANT_PRICING_REVIEWED = 'merchant_pricing.reviewed'
export const EXPORT_ORDER_FINISHED = 'export.order.finished'

const RELOAD = 'reload'
const KICKOUT = 'kickout'

const hooks = [
  MERCHANT_PRICING_ADDED,
  MERCHANT_PRICING_REVIEWED,
  EXPORT_ORDER_FINISHED
]

const emitHook = (hook) => (e) => {
  try {
    events.emit(hook, e.data ? JSON.parse(e.data) : undefined)
  } catch (err) {
    console.warn('SSE parse failed', err)
  }
}

const reload = () => document.location.reload()

export default {
  listen() {
    const es = new EventSource('/listen/channels/crm', { withCredentials: true })
    es.addEventListener(RELOAD, reload)
    es.addEventListener(KICKOUT, reload)
    for (const hook of hooks) {
      es.addEventListener(hook, emitHook(hook))
    }
    return es
  }
}
